// We need global event bus to communicate between components
import Vue from 'vue';

export const EventBus = new Vue();
